import { AMBrand } from 'src/common-services'
import { useRecoilState, useSetRecoilState } from 'recoil'
import * as brandsLayerAtoms from 'src/atoms/brands-rank-layer'
import { useClearLocation } from 'src/hooks/use-clear-location'
import { useCachedRecoilValue } from 'src/utils/recoil'
import * as searchAtoms from 'src/atoms/search'
import * as mapToolsAtoms from 'src/atoms/main-map-tools'

/** Layer used in main map */
export const useBrandsRankLayer = () => {
  const setFilter = useSetRecoilState(brandsLayerAtoms.filter)
  const setBrandsRankLayerActive = useSetRecoilState(brandsLayerAtoms.active)
  const [selectedBrands, setSelectedBrands] = useRecoilState(brandsLayerAtoms.selectedBrands)
  const clearLocation = useClearLocation()
  const location = useCachedRecoilValue(searchAtoms.selectedLocation, undefined)
  const [selectedTool, setSelectedTool] = useRecoilState(mapToolsAtoms.mapPinsTools)

  const addBrand = (brand: AMBrand) => {
    const existingBrand = selectedBrands.find((x) => x.id === brand.id)
    if (existingBrand) {
      return
    }

    if (selectedBrands.length === 0) {
      clearLocation(true)
    }
    setSelectedBrands((prev) => [...prev, brand])
    setBrandsRankLayerActive(true)
  }

  const removeBrand = (brand: AMBrand) => {
    if (location?.brandId === brand.id) {
      clearLocation()
    }
    setSelectedBrands((prev) => prev.filter((x) => x.id !== brand.id))
  }

  const closeBrandsRankLayer = (clearSelectedLocation = true) => {
    if (selectedTool === 'brands') {
      setSelectedTool(null)
    }
    setFilter('')
    setSelectedBrands([])
    setBrandsRankLayerActive(false)
    if (clearSelectedLocation) {
      clearLocation(true)
    }
  }

  return { addBrand, closeBrandsRankLayer, removeBrand }
}
